import React, { useMemo } from 'react';
import { hours } from '../data/shop';
import { getOpenStatus } from '../utils/hours';
type OpenStatusProps = {
  tone?: 'light' | 'dark';
};
export function OpenStatus({
  tone = 'dark'
}: OpenStatusProps) {
  const status = useMemo(() => getOpenStatus(hours, new Date()), []);
  const textColor = tone === 'light' ? 'text-white' : 'text-ink';
  return <span className={`inline-flex items-center gap-2 text-sm font-medium ${textColor}`} data-id="element-193" data-mp="3pqjdrqtlr057">
      <span aria-hidden="true" className={`h-2 w-2 rounded-full ${status.isOpen ? 'bg-success' : tone === 'light' ? 'bg-white/40' : 'bg-muted/50'}`} data-id="element-194" data-mp="3pse0naofp2bx" />
      {status.label}
    </span>;
}